// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Scale = function Scale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.172.77h5.192c.48 0 .866.386.866.865v5.192a.864.864 0 0 1-1.479.613l-1.406-1.406-3.137 3.137a.86.86 0 0 1-1.222 0l-1.154-1.154a.86.86 0 0 1 0-1.222l3.137-3.137-1.41-1.41A.867.867 0 0 1 13.172.77M6.827 19.23H1.635a.863.863 0 0 1-.865-.865v-5.192a.864.864 0 0 1 1.478-.613l1.406 1.406 3.137-3.137a.86.86 0 0 1 1.222 0l1.154 1.154a.86.86 0 0 1 0 1.222L6.03 16.342l1.406 1.406a.866.866 0 0 1-.613 1.478z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
